import { useState, useContext } from "react"
import { Auth } from 'aws-amplify';
import { AuthContext } from './Authentication';
import { APIsHandlerContext } from './APIs';
import { useNavigate, useParams } from "react-router-dom";
import "./styles/Signup.css"

String.prototype.removeCharAt = function (i) {
    console.log("Tentando remover o index " + i + ". a string começa com " + this);
    var tmp = this.split(''); // convert to an array
    tmp.splice(i - 1 , 1); // remove 1 element from the array (adjusting for non-zero-indexed counts)
    var juntada = tmp.join('');
    console.log("termina com " + juntada);
    return tmp.join(''); // reconstruct the string
}
const normalizeInput = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7) return `(${currentValue.slice(0, 2)}) ${currentValue.slice(2)}`;
      return `(${currentValue.slice(0, 2)}) ${currentValue.slice(2, 7)}-${currentValue.slice(7, 11)}`;
    }
  };

export default function Signup() {
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCPF] = useState('');
  const [phone_number, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConf, setPasswordConf] = useState('');
  const [alertVisible, setAlertVisibility] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  let username = 'asass';
  let phone_number_corrigido = "";
  const { signUp, user, setUsername } = useContext(AuthContext);
  const { newDeviceAPIPost } = useContext(APIsHandlerContext);
  const navigate = useNavigate();
  const { deviceid } = useParams();

    

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password !== passwordConf)        {
            setErrorMessage("Senhas inseridas não correspondem.")
            setAlertVisibility(true);
            return;
        } 
        else
        {
            setAlertVisibility(false);
        }
        phone_number_corrigido = phone_number.replace('(','');
        phone_number_corrigido = phone_number_corrigido.replace(')','');
        phone_number_corrigido = phone_number_corrigido.replace(' ','');
        phone_number_corrigido = phone_number_corrigido.replace('-','');
        phone_number_corrigido = "+55" + phone_number_corrigido;
        phone_number_corrigido = phone_number_corrigido.removeCharAt(6);
        console.log("Clicou submit novo usuario. phone_number_corrigido = " + phone_number_corrigido);
        username = email;
        signUp(username, password, email, name, cpf, phone_number_corrigido).then(resp =>{
            console.log("NovoUsuario.js then resp", resp);
            console.log("NovoUsuario.js then resp.user", resp.user);
            console.log("NovoUsuario.js then resp.userConfirmed", resp.userConfirmed);            
            console.log("NovoUsuario.js then resp.userSub", resp.userSub);
            if (resp.username)
            {
                console.log(resp.username);
                //fez o signup certinho, vai para a pagina de verificacao
            }
            if (resp.name)
            {
                switch(resp.name)
                {
                    case 'InvalidPasswordException':
                        setErrorMessage("Senha deve conter: mín. 8 caracteres, mín. 1 número, mín. 1 caractere especial (#!@$%), mín. 1 letra maiúscula, mín. 1 letra minúscula")
                        setAlertVisibility(true);
                        break;
                    case 'UsernameExistsException':
                        setErrorMessage("Usuario já cadastrado");
                        setAlertVisibility(true);
                        break;
                }
                return;
            }
            setUsername(username);
            newDeviceAPIPost(email, deviceid)
            .then(resp => {
                console.log("NovoUsuario.js resp = ", resp);
                navigate("/verificacao");
            }).catch(err => {
                console.log("NovoUsuario.js err = ", err);
            });
        }).catch(err => { console.log("NovoUsuario.js catch ", err); });
    }

  return (
    <div className="user-login">
        <h2>NovoUsuario</h2>
        <form onSubmit={handleSubmit}>
            <label>Nome:</label>
            <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <label>CPF/CNPJ:</label>
            <input
                type="text"
                placeholder="xxx.xxx.xxx-xx"
                required
                value={cpf}
                onChange={(e) => setCPF(e.target.value)}
            />
            <label>E-mail:</label>
            <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <label>Telefone:</label>
            <input
                type="text"
                name="phone"
                placeholder="(xx) xxxxx-xxxx"
                required
                value={phone_number}
                onChange={(e) => setPhone(normalizeInput(e.target.value, phone_number))}
            />
            <label>Senha:</label>
            <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <label>Confirmar Senha:</label>
            <input
                type="password"
                required
                value={passwordConf}
                onChange={(e) => setPasswordConf(e.target.value)}
            />
            <input type="submit" value="Registrar"></input>
        </form>
        { alertVisible && <p>{ errorMessage }</p>}
    </div>
  )
}
